// extracted by mini-css-extract-plugin
module.exports = {"ImageDetailModalRoot":"index-ImageDetailModalRoot-2srmS","imagePanel":"index-imagePanel-1kOVp","downBtn":"index-downBtn-gQIOA","closeBtn":"index-closeBtn-oM-_y"};